import React, { useRef } from 'react';
import { useInView } from 'framer-motion';
interface LazyMountProps {
  children: React.ReactNode;
  /** Clase del contenedor: debe reservar el espacio final (evita saltos). */
  className?: string;
  /** Distancia de anticipación antes de montar el contenido. */
  margin?: string;
  placeholder?: React.ReactNode;
}

/**
 * Monta su contenido solo cuando está cerca del viewport. Sirve para bloques
 * pesados (piezas grandes, iframes) sin afectar la carga inicial en móvil.
 */
export function LazyMount({
  children,
  className,
  margin = '400px',
  placeholder
}: LazyMountProps) {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin
  });
  return <div ref={ref} className={className} data-id="element-183" data-mp="237awcfmdnyke">
      {inView ? children : placeholder}
    </div>;
}